import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getAvailableLanguages: ['payload'],
  getAvailableLanguagesStart: ['payload'],
  getAvailableLanguagesSuccess: ['payload'],
  getAvailableLanguagesFail: ['payload'],

  getLanguageLabel: ['payload'],
  getLanguageLabelStart: ['payload'],
  getLanguageLabelSuccess: ['payload'],
  getLanguageLabelFail: ['payload'],

  updateUserLanguagePreference: ['payload'],
  updateUserLanguagePreferenceStart: ['payload'],
  updateUserLanguagePreferenceSuccess: ['payload'],
  updateUserLanguagePreferenceFail: ['payload'],

  getUserLanguagePreference: ['payload'],
  getUserLanguagePreferenceStart: ['payload'],
  getUserLanguagePreferenceSuccess: ['payload'],
  getUserLanguagePreferenceFail: ['payload'],

  addUpdateLanguageLabelText: ['payload'],
  addUpdateLanguageLabelTextStart: ['payload'],
  addUpdateLanguageLabelTextSuccess: ['payload'],
  addUpdateLanguageLabelTextFail: ['payload'],

  getLocaleStrings: ['payload'],
  getLocaleStringsStart: ['payload'],
  getLocaleStringsSuccess: ['payload'],
  getLocaleStringsFail: ['payload'],
  clearSuccessMessage: ['payload'],

  syncLanguageLabels: ['payload'],
  syncLanguageLabelsStart: ['payload'],
  syncLanguageLabelsSuccess: ['payload'],
  syncLanguageLabelsFail: ['payload']
});
